
import React from 'react';

interface ChatPresenceStatusProps {
  userIdToTrack: string | null;
  isUserOnline: (userId: string) => boolean;
}

const ChatPresenceStatus: React.FC<ChatPresenceStatusProps> = ({
  userIdToTrack,
  isUserOnline
}) => {
  if (!userIdToTrack) {
    console.log('[ChatPresenceStatus] No userIdToTrack available');
    return null;
  }
  
  const isOnline = isUserOnline(userIdToTrack);
  console.log(`[ChatPresenceStatus] Status for user ${userIdToTrack}: online=${isOnline}`);
  
  if (isOnline) {
    return (
      <div className="flex items-center text-sm text-green-500">
        <div className="w-2 h-2 rounded-full bg-green-500 mr-2 animate-pulse" />
        <span>Online</span>
      </div>
    );
  } else {
    return (
      <div className="flex items-center text-sm text-gray-500">
        <div className="w-2 h-2 rounded-full bg-gray-500 mr-2" />
        <span>Offline</span>
      </div>
    );
  }
};

export default ChatPresenceStatus;
